import * as React from "react";
const SvgAirtable = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 178 148",
  shapeRendering: "geometricPrecision",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FCB400",
  d: "M79 1.867L13.04 29.16c-3.668 1.518-3.63 6.729.061 8.192l66.235 26.266a24.575 24.575 0 0 0 18.12 0l66.236-26.267c3.69-1.462 3.73-6.672.06-8.19L97.794 1.866a24.578 24.578 0 0 0-18.795 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#18BFFF",
  d: "M94.273 77.96v65.617c0 3.12 3.147 5.258 6.048 4.108l73.806-28.648a4.418 4.418 0 0 0 2.79-4.108V49.313c0-3.121-3.147-5.258-6.048-4.108L97.063 73.853a4.42 4.42 0 0 0-2.79 4.108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F82B60",
  d: "M77.038 81.346L55.134 91.922l-2.224 1.075-46.238 22.155C3.742 116.566 0 114.43 0 111.174V49.588c0-1.178.604-2.195 1.414-2.96a5.024 5.024 0 0 1 1.12-.84c1.104-.663 2.68-.84 4.02-.31L76.67 73.26c3.564 1.414 3.844 6.408.368 8.087"
}), /*#__PURE__*/React.createElement("path", {
  fill: "rgba(0, 0, 0, 0.25)",
  d: "M77.038 81.346L55.134 91.922 1.414 46.627a5.024 5.024 0 0 1 1.12-.839c1.104-.663 2.68-.84 4.02-.31L76.67 73.26c3.564 1.414 3.844 6.408.368 8.087"
}));
export default SvgAirtable;
//# sourceMappingURL=Airtable.js.map